<template>
  <div id="app">
    <router-view  keep-alive transition-mode="out-in" />
  </div>
</template>

<script>
export default {
  name: 'layoutLogin'
}
</script>



// WEBPACK FOOTER //
// src/layouts/login.vue